import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { EstimateSettingsService } from './estimate-settings.service';

export const EstimateListGuard: CanActivateFn = async () => {
  const settingsService = inject(EstimateSettingsService);
  const router = inject(Router);
  const canActivate = await settingsService.getRestrictEstimateListAccess();

  return canActivate || router.parseUrl('/app/welcome');
};
